<template>
  <v-container>
    <v-card>
      <attendance-monthly-attendance :employee-uid="employee.employee_uid" />
    </v-card>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    components: {
      AttendanceMonthlyAttendance: () => import('@/components/attendances/MonthlyAttendance'),
    },
    metaInfo () {
      return {
        title: 'Attendance',        
      }
    },
    computed: {  
      ...mapState({ employee: 'currentEmployee' }),
    },
  }
</script>
